var _react_refresh_temp_1;
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
const Avatar = ({ participant }) => {
    const render = () => {
        if (participant.metadata.profile_pic) {
            return (_jsx("img", { src: participant.metadata.profile_pic, alt: participant.name }));
        }
        else {
            return _jsx(_Fragment, { children: participant.name.slice(0, 2).toUpperCase() });
        }
    };
    return (_jsx("div", { className: "thumb h-[22px] xl:h-[30px] w-[22px] xl:w-[30px] ltr:mr-2 rtl:ml-2 rounded-full overflow-hidden bg-primaryColor flex items-center justify-center text-white text-xs xl:text-sm", children: render() }));
};
_react_refresh_temp_1 = Avatar;
$RefreshReg$(_react_refresh_temp_1, "Avatar");
export default Avatar;
